export const GROUP_MAPPING_DEFAULT_ROWS_SIZE = 4

export const GROUP_MAPPING_STATES = {
  ACTIVATED: 'activated',
  DEACTIVATED: 'deactivated',
  SYNCING: 'syncing'
}

export const GROUP_PAGE_SIZE = 20

export const SCIM_STATES = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  SYNC_ERROR: 'sync_error',
  SYNCING: 'syncing',
}


export const USER_PROVISIONING_STEPS = {
  SCIM_PROVISIONING: 1,
  GROUP_MAPPING: 2
}
